import cn from "classnames";
import { Spacer } from "../Spacer/Spacer";
import { Text } from "../Text/Text";

import Styles from "./Spinner.module.scss";

interface Props {
  label?: string;
  /** Render as a fixed, full-viewport centered overlay that blocks the page while an async action runs. */
  overlay?: boolean;
}

export const Spinner = ({ label, overlay = false }: Props) => {
  return (
    <div
      className={cn(Styles.container, { [Styles.overlay]: overlay })}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={Styles.dotContainer}>
        <div className={cn(Styles.dot, Styles.dot1)} />
        <div className={cn(Styles.dot, Styles.dot2)} />
        <div className={cn(Styles.dot, Styles.dot3)} />
        <div className={cn(Styles.dot, Styles.dot4)} />
      </div>
      {label ? (
        <>
          <Spacer.Vertical size={"xs"} />
          <Text>{label}</Text>
        </>
      ) : null}
    </div>
  );
};
